import { render, staticRenderFns } from "./PageCheck.vue?vue&type=template&id=61fb1122&scoped=true&"
import script from "./PageCheck.vue?vue&type=script&lang=js&"
export * from "./PageCheck.vue?vue&type=script&lang=js&"
import style0 from "./PageCheck.vue?vue&type=style&index=0&id=61fb1122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb1122",
  null
  
)

export default component.exports